import React from "react";
import {OwnSecondFactor} from "../components";

/** «Настройки» кабинета мерчанта и трейдера: вход открывается из блока с логином рядом с «Выйти». */
export function SettingsPage(): JSX.Element {
    return (
        <div className="page settings-page">
            <header className="page-header">
                <div>
                    <h1>Настройки</h1>
                    <p className="page-subtitle">Вход в кабинет</p>
                </div>
            </header>
            <OwnSecondFactor/>
        </div>
    );
}
